<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import axios from "axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "DISCOUNTS ALLOWED",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "DISCOUNTS ALLOWED",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "DISCOUNTS ALLOWED",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "customer",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },

        {
          key: "user",
          sortable: true,
          label: "USER",
        },

        {
          key: "addedon",
          sortable: true,
          label: "RECORDED ON",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        },

      ],


      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        customer: "",
        branch_id: 0,
        receipt: ''
      },

      totals: {
        totalAmount: 0,
        totalDiscount: 0,
      },

    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("saledetails", ["SaveStatus", "Discounts", "filterStatus"]),
    ...mapGetters("customers", ["Customers"]),
    ...mapGetters("auth", ["MyUserPerm", "business", "branch", "Branches", "branchid"]),
    ...mapGetters("setting", ["GeneralSettings",]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Discounts ? this.Discounts.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Discounts ? this.Discounts.length : 1;
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },

    Discounts(newValue) {
      if (newValue) {
        this.SalesData();
      }
    }
  },
  methods: {
    ...mapActions({
      FetchDiscounts: "saledetails/fetchDiscounts",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",

    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },


    SalesData() {
      if (this.Discounts) {
        let total_amount = 0;
        let total_discount = 0;
        this.Discounts.forEach((item) => {
          total_amount = total_amount + parseInt(item.totalAmt);
          total_discount = total_discount + parseInt(item.discount);
        });
        this.totals.totalAmount = total_amount;
        this.totals.totalDiscount = total_discount;
      }
    },

    filterReport() {
      this.FetchDiscounts(this.data);
    },





  },
  created() {
    this.FetchDiscounts(this.data);
    this.FetchGeneralSettings();
    this.FetchBranches();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>

                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []" v-model="data.branch_id" option-value="id"
                  option-text="name" placeholder="Select Branch" @input="filterReport()">
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>From</label>
                  <input @change="filterReport()" type="date" v-model="data.datefrom" class="form-control" />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>To</label>
                  <input @change="filterReport()" type="date" v-model="data.dateto" class="form-control" />
                </div>
              </div>


              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="filterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class=" col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-md-4">

              </div>
              <!-- Search -->
              <div class="col-md-4">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="Discounts ? Discounts : []" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(tt_amt)="data">
                  {{ thousandSeperator(data.item.totalAmt) }}
                </template>

                <template #cell(discount_field)="data">
                  {{ thousandSeperator(data.item.discount) }}
                </template>


              </b-table>
              <div class="row">
                <div class="col-md-3">
                  <h5>Total Amount: <span class="text-danger">{{ thousandSeperator(totals.totalAmount) }}</span></h5>
                </div>

                <div class="col-md-3">
                  <h5>Total Discount: <span class="text-danger">{{ thousandSeperator(totals.totalDiscount) }}</span></h5>
                </div>

              </div>
            </div>
            <Loader v-if="!Discounts" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>
